function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicemailNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "voicemail_new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "voicemail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.46,13.62a6,6,0,0,0-5.91,5.91,6,6,0,0,0,1.39,3.77H13a6,6,0,0,0,1.4-3.77,6,6,0,0,0-5.92-5.91,5.92,5.92,0,0,0,0,11.83h14a5.92,5.92,0,1,0,0-11.83Zm-14,9.68a3.77,3.77,0,0,1,0-7.53,3.77,3.77,0,1,1,0,7.53Zm14,0a3.77,3.77,0,1,1,3.76-3.77A3.81,3.81,0,0,1,22.46,23.3Z",
    style: {
      fill: "gray"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "25.53 8.18 26.68 10.4 30.44 8.27 28.3 12.03 30.53 13.18 28.3 14.32 30.44 18.09 26.68 15.95 25.53 18.18 24.38 15.95 20.62 18.09 22.76 14.32 20.53 13.18 22.76 12.03 20.62 8.27 24.38 10.4 25.53 8.18",
    style: {
      fill: "#e9c181"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.53,
    y: 12.18,
    width: 2,
    height: 2,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemailNew);
export default __webpack_public_path__ + "static/media/voicemail_new.d56d01d0.svg";
export { ForwardRef as ReactComponent };